/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/date';
import '../../common/sort';
import '../../resources/error';
import '../resources/datatypes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "SearchCatalogImagesTextFilter": {
                        "fields": {
                          "exact": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "fuzzy": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SearchCatalogImagesField": {
                        "values": {
                          "SEARCH_CATALOG_IMAGES_FIELD_DO_NOT_USE": 0,
                          "NAME": 1,
                          "ITEM_NAME": 2,
                          "IMAGE_CREATED_AT": 3,
                          "IMAGE_UPDATED_AT": 4,
                          "PHOTO_STUDIO_ORDER_ID": 5
                        }
                      },
                      "SearchCatalogImagesMultiFieldTextFilter": {
                        "fields": {
                          "query": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesTextFilter",
                            "id": 1,
                            "rule": "optional"
                          },
                          "fields": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesFieldValue",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SearchCatalogImagesFieldValue": {
                        "fields": {
                          "any": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesField",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "all": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesField",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "none": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesField",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SearchCatalogImagesFilter": {
                        "fields": {
                          "name": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesTextFilter",
                            "id": 1,
                            "rule": "optional"
                          },
                          "itemName": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesTextFilter",
                            "id": 2,
                            "rule": "optional"
                          },
                          "imageCreatedAt": {
                            "type": "squareup.connect.v2.common.TimeRange",
                            "id": 3,
                            "rule": "optional"
                          },
                          "imageUpdatedAt": {
                            "type": "squareup.connect.v2.common.TimeRange",
                            "id": 4,
                            "rule": "optional"
                          },
                          "multiField": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesMultiFieldTextFilter",
                            "id": 5,
                            "rule": "optional"
                          },
                          "photoStudioOrderId": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesTextFilter",
                            "id": 6,
                            "rule": "optional"
                          },
                          "photoStudioOrderIdPresent": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "imageIds": {
                            "type": "string",
                            "id": 8,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SearchCatalogImagesRequest": {
                        "fields": {
                          "query": {
                            "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesRequest.Query",
                            "id": 1,
                            "rule": "optional"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "limit": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": 20
                            }
                          }
                        },
                        "nested": {
                          "Query": {
                            "fields": {
                              "filter": {
                                "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesFilter",
                                "id": 1,
                                "rule": "optional"
                              },
                              "sort": {
                                "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesRequest.Query.Sort",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Sort": {
                                "fields": {
                                  "field": {
                                    "type": "squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesField",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "sortOrder": {
                                    "type": "squareup.connect.v2.common.SortOrder",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": "ASC"
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "SearchCatalogImagesResponse": {
                        "fields": {
                          "errors": {
                            "type": "squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "objects": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogImagesTextFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogImagesField && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogImagesMultiFieldTextFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogImagesFieldValue && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogImagesFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogImagesRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogImagesRequest?.nested?.Query && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogImagesRequest?.nested?.Query?.nested?.Sort && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.SearchCatalogImagesResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc An exact or fuzzy text filter to return [CatalogImage](entity:CatalogImage) objects that match
 * a searchable string attribute of image objects against a specified query text. The text filter must be exact or fuzzy.
 * --
 *
 * SOURCE SearchCatalogImagesTextFilter @ squareup/connect/v2/catalog/interfaces/search-catalog-images.proto at 26:1
 */
export const SearchCatalogImagesTextFilter = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesTextFilter');
fixType(SearchCatalogImagesTextFilter);
Builder.createAndAttachToType(SearchCatalogImagesTextFilter);
/**
 * --
 * @desc Searchable image properties for use in [SearchCatalogImagesMultiFieldTextFilter](entity:SearchCatalogImagesMultiFieldTextFilter).
 * --
 *
 * SOURCE SearchCatalogImagesField @ squareup/connect/v2/catalog/interfaces/search-catalog-images.proto at 43:1
 */
export const SearchCatalogImagesField = $root.lookupEnum('squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesField').values;
/**
 * --
 * @desc A text filter to search for [CatalogImage](entity:CatalogImage) objects by matching a set
 * of searchable image properties against a specified query string,
 * subject to a specified query clause of `all`, `any`, and `none`.
 * --
 *
 * SOURCE SearchCatalogImagesMultiFieldTextFilter @ squareup/connect/v2/catalog/interfaces/search-catalog-images.proto at 75:1
 */
export const SearchCatalogImagesMultiFieldTextFilter = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesMultiFieldTextFilter');
fixType(SearchCatalogImagesMultiFieldTextFilter);
Builder.createAndAttachToType(SearchCatalogImagesMultiFieldTextFilter);
/**
 * --
 * @desc Supported query clauses to return [CatalogImage](entity:CatalogImage) objects by matching a
 * query string against a specified set of searchable image properties.
 * --
 *
 * SOURCE SearchCatalogImagesFieldValue @ squareup/connect/v2/catalog/interfaces/search-catalog-images.proto at 92:1
 */
export const SearchCatalogImagesFieldValue = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesFieldValue');
fixType(SearchCatalogImagesFieldValue);
Builder.createAndAttachToType(SearchCatalogImagesFieldValue);
/**
 * --
 * @desc An image query filter to search for [CatalogImage](entity:CatalogImage) objects using one or
 * more component filters
 * to match the following image properties against the corresponding query values:
 * - The `name`, `creation_at`, and `updated_at` attributes of [CatalogImage](entity:CatalogImage)
 * objects.
 * - The `name` attribute of [CatalogItem](entity:CatalogItem) objects to which targeted image
 * objects are attached.
 * - The `photo_studio_order_id` attribute of [CatalogItem](entity:CatalogItem) objects for images
 * created by the Photo Studio service of Square Online Store.
 * In addition, this image query filter also supports using a `multi_field` text filter by matching a
 * set of the above image properties against a specified query string, subject to the `all`, `any`,
 * or `none` [query clause](entity:SearchCatalogImagesFieldValue).
 * --
 *
 * SOURCE SearchCatalogImagesFilter @ squareup/connect/v2/catalog/interfaces/search-catalog-images.proto at 129:1
 */
export const SearchCatalogImagesFilter = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesFilter');
fixType(SearchCatalogImagesFilter);
Builder.createAndAttachToType(SearchCatalogImagesFilter);
/**
 * SOURCE SearchCatalogImagesRequest @ squareup/connect/v2/catalog/interfaces/search-catalog-images.proto at 182:1
 */
export const SearchCatalogImagesRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesRequest');
fixType(SearchCatalogImagesRequest);
Builder.createAndAttachToType(SearchCatalogImagesRequest);
/**
 * --
 * @desc An image object query consisting of specified image filtering conditions and a sort order
 * on the returned result.
 * --
 *
 * SOURCE Query @ squareup/connect/v2/catalog/interfaces/search-catalog-images.proto at 190:5
 */
SearchCatalogImagesRequest.Query = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesRequest.Query');
fixType(SearchCatalogImagesRequest.Query);
Builder.createAndAttachToType(SearchCatalogImagesRequest.Query);
/**
 * --
 * @desc  Sort criteria with an ordering on the specified sorting attribute to return queried
 * image objects.
 * --
 *
 * SOURCE Sort @ squareup/connect/v2/catalog/interfaces/search-catalog-images.proto at 200:9
 */
SearchCatalogImagesRequest.Query.Sort = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesRequest.Query.Sort');
fixType(SearchCatalogImagesRequest.Query.Sort);
Builder.createAndAttachToType(SearchCatalogImagesRequest.Query.Sort);
/**
 * SOURCE SearchCatalogImagesResponse @ squareup/connect/v2/catalog/interfaces/search-catalog-images.proto at 230:1
 */
export const SearchCatalogImagesResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesResponse');
fixType(SearchCatalogImagesResponse);
Builder.createAndAttachToType(SearchCatalogImagesResponse);